/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResourceFilterName } from './ResourceFilterName';
import {
    ResourceFilterNameFromJSON,
    ResourceFilterNameFromJSONTyped,
    ResourceFilterNameToJSON,
    ResourceFilterNameToJSONTyped,
} from './ResourceFilterName';
import type { ResourceFilterType } from './ResourceFilterType';
import {
    ResourceFilterTypeFromJSON,
    ResourceFilterTypeFromJSONTyped,
    ResourceFilterTypeToJSON,
    ResourceFilterTypeToJSONTyped,
} from './ResourceFilterType';

/**
 * 
 * @export
 * @interface GeneratorFilterTypeRepresentation
 */
export interface GeneratorFilterTypeRepresentation {
    /**
     * 
     * @type {ResourceFilterName}
     * @memberof GeneratorFilterTypeRepresentation
     */
    name: ResourceFilterName;
    /**
     * 
     * @type {ResourceFilterType}
     * @memberof GeneratorFilterTypeRepresentation
     */
    inputtype: ResourceFilterType;
    /**
     * regex pattern for input
     * @type {string}
     * @memberof GeneratorFilterTypeRepresentation
     */
    pattern?: string;
    /**
     * whitelist for values, if empty => free input allowed
     * @type {Array<string>}
     * @memberof GeneratorFilterTypeRepresentation
     */
    whitelist?: Array<string>;
}



/**
 * Check if a given object implements the GeneratorFilterTypeRepresentation interface.
 */
export function instanceOfGeneratorFilterTypeRepresentation(value: object): value is GeneratorFilterTypeRepresentation {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('inputtype' in value) || value['inputtype'] === undefined) return false;
    return true;
}

export function GeneratorFilterTypeRepresentationFromJSON(json: any): GeneratorFilterTypeRepresentation {
    return GeneratorFilterTypeRepresentationFromJSONTyped(json, false);
}

export function GeneratorFilterTypeRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratorFilterTypeRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'name': ResourceFilterNameFromJSON(json['name']),
        'inputtype': ResourceFilterTypeFromJSON(json['inputtype']),
        'pattern': json['pattern'] == null ? undefined : json['pattern'],
        'whitelist': json['whitelist'] == null ? undefined : json['whitelist'],
    };
}

export function GeneratorFilterTypeRepresentationToJSON(json: any): GeneratorFilterTypeRepresentation {
    return GeneratorFilterTypeRepresentationToJSONTyped(json, false);
}

export function GeneratorFilterTypeRepresentationToJSONTyped(value?: GeneratorFilterTypeRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': ResourceFilterNameToJSON(value['name']),
        'inputtype': ResourceFilterTypeToJSON(value['inputtype']),
        'pattern': value['pattern'],
        'whitelist': value['whitelist'],
    };
}

